export const OUTBRAIN_SCRIPT = "https://widgets.outbrain.com/outbrain.js";
